import type { GatsbyBrowser } from 'gatsby';
import './src/styles/global.css';

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  // Initialize theme on client load
  const savedTheme = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const isDark = savedTheme === 'dark' || (!savedTheme && prefersDark);

  if (isDark) {
    document.documentElement.classList.add('dark');
  }
};
